var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitecoinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.001 440C384.001 462.092 366.093 480 344.001 480H104.005C81.913 480 64.005 462.092 64.005 440V280.137L40.804 286.766C37.866 287.609 34.897 288.016 31.991 288.016C18.069 288.016 5.257 278.844 1.241 264.797C-3.618 247.797 6.225 230.094 23.21 225.234L64.005 213.578V72C64.005 49.906 81.911 32 104.005 32C126.096 32 144.003 49.906 144.003 72V190.721L247.202 161.234C264.233 156.328 281.905 166.219 286.764 183.203C291.624 200.203 281.78 217.906 264.796 222.766L144.003 257.279V400H344.001C366.093 400 384.001 417.908 384.001 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoinSign);
export default __webpack_public_path__ + "static/media/litecoin-sign.ec33b8f531232b6b78ebf34cab3334a8.svg";
export { ForwardRef as ReactComponent };